module.exports = __webpack_public_path__ + "static/media/twitter.7e4bcfc7.svg";